module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(!_vm.disable && !_vm.visualiza) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.adicionando) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar Dirigente / Designado ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.adicionando) ? _c('div', {
    staticClass: "column all-start adicionar-dirigente-container"
  }, [_c('div', {
    staticClass: "row-flex all-start required-field w-100"
  }, [_c('label', {
    staticClass: "control-label col-md-4 w-100",
    attrs: {
      "for": "forma_jurídica"
    }
  }, [_vm._v(" Dirigente/Designado: ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dirigenteSelecionado),
      expression: "dirigenteSelecionado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dirigenteSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione um Dirigente / Designado:")]), _vm._v(" "), _vm._l((_vm.dirigentesParaAdicionar), function(dirigente) {
    return _c('option', {
      domProps: {
        "value": dirigente
      }
    }, [_vm._v(_vm._s(dirigente.ds_nome))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Adicionar ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "tooltip": "Adiciona um dirigente / designado para Assinar o Convênio com a Fundação BB",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adicionando = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tableDirigentes",
    attrs: {
      "how-empty": "",
      "stacked": "md",
      "id": "dirigentes-table",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.inativosMostrarOcultar,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ds_nome",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value) + "    "), _c('span', {
          staticStyle: {
            "color": "cornflowerblue"
          }
        }, [_vm._v(_vm._s(row.item.cargo.ds_descricao))])]
      }
    }, {
      key: "dt_inicio_mandato",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "dt_fim_mandato",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!_vm.disable && !_vm.visualiza) ? _c('div', [_c('b-button', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.exclui(row); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>APAGAR</b> o dirigente / designado ' + row.item.ds_nome + ' ?'
            }),
            expression: "{ok: retorno => exclui(row), cancel: doNothing,\n                            message: 'Deseja <b>APAGAR</b> o dirigente / designado ' + row.item.ds_nome + ' ?'}"
          }],
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1) : _c('div', [_vm._v("\n                  -\n                ")])]
      }
    }, {
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-711e9c24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/assinaturaDirigentes.vue
// module id = 2012
// module chunks = 1